<script setup></script>

<template>
  <div class="absolute mt-[-65px] left-[5px] origin-bottom-left scale-[0.4] xs:scale-[0.45] sm:scale-[0.5] md:scale-[0.55] lg:scale-[0.6]">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100px" height="67.4px" xml:space="preserve">
      <path
        d="M17.3,19.2C23,8.8,30.5,0,40.4,0c3.8,0,5.3,1.7,5.3,3.9c0,3.4-3.7,8.4-8.4,9.2l-0.7-1.7c2-0.8,4.2-5.1,0.8-5.1
      c-5.2,0-8.7,7.1-11.3,12.8h3.2c2.3,0,3.9,0.1,3.9,1c0,1.1-2.1,4.4-3.1,4.4h-6.5l-19,40.9c-0.5,0.9-1,1.9-1.7,1.9
      c-0.3,0-0.6-0.2-0.8-0.5c-3.9-6.7-2.3-10.7,3.2-22.7l9.1-19.6c-2,0-3.3-0.1-3.3-1c0-1.1,2.1-4.4,3.1-4.4H17.3z"
      />
      <path
        d="M42.5,49.2c-10.1,0-13.3-5-13.3-10.6c0-8.7,8.5-19.9,21.9-19.9c10.1,0,13.6,4.9,13.6,10.6C64.7,38.1,55.9,49.2,42.5,49.2z
                  M55.2,29.6c0-3.1-2-5.7-5.5-5.7c-6,0-11,8.6-11,14.3c0,3.1,2.1,5.7,5.7,5.7C50.4,43.9,55.2,35.2,55.2,29.6z"
      />
      <path
        d="M74.2,26.8c1.4-3.9-1.7-3.6-4.3-2.3L69,22.8c2.8-1.5,7-4.2,10.9-4.2c2.6,0,4.6,1,4.6,3.6c0,0.6-0.1,1.2-0.2,1.9
      c2.9-3,6.5-5.4,10.8-5.4c3,0,4.9,2.1,4.9,4.6c0,4.1-4.3,7.7-8.3,8.6L91,30.1c1.5-0.8,2.6-1.9,2.6-3.2c0-1.2-0.8-2.2-3-2.2
      c-4.5,0-7.7,3.3-9.7,7l-7.3,15.7c-0.5,0.9-1,1.9-1.7,1.9c-2.1,0-4-2-4-4.9c0-4.6,3.5-11.9,5.4-15.9L74.2,26.8z"
      />
    </svg>
  </div>
</template>
